/**
 * For safety to get window in server side
 */
export function useWindow() {
  if (typeof globalThis === "undefined") return;
  return globalThis;
}
